import { useCallback, useState } from 'react';

export const useGlobalError = () => {
  const [, setGlobalError] = useState<unknown>();
  return useCallback(
    (e: unknown) => {
      setGlobalError(() => {
        throw e;
      });
    },
    [setGlobalError]
  );
};
